<script setup lang="ts">
import {defineProps} from 'vue';

const props = defineProps(
    {
      heroInfos:{}
    }
  );
console.log(props.heroInfos)
</script>

<template>
  <div class="impx-page-heading uk-position-top gallery">
    <div class="impx-overlay dark"></div>
    <div class="uk-container">
      <div class="uk-width-1-1">
        <div class="uk-flex uk-flex-left">
          <div class="uk-light uk-position-relative uk-text-left page-title">
            <h1 class="uk-margin-remove">{{props.heroInfos?.title}}</h1><!-- page title -->
            <p class="impx-text-large uk-margin-remove">{{props.heroInfos?.subtitle}}</p><!-- page subtitle -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>